module.exports = __webpack_public_path__ + "img/oufu_41x60x7b.prt.d3616394.jpg";